import type { CSSProperties } from 'react';
import MagicWandIconSvg from '../../assets/icons/magic_wand.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const MagicWandIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <MagicWandIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default MagicWandIcon;
